export const RESOURCE_CTA_ACTION_PROTOCOL = 'hyrox-action:';

export type ResourceCtaActionName = 'gym-update-link';
export type ResourceCtaActionContext = {
  targetWindow: Window | null;
};
export type ResourceCtaActionHandler = (context: ResourceCtaActionContext) => Promise<void>;
export type ResourceCtaActionHandlers = Partial<Record<ResourceCtaActionName | string, ResourceCtaActionHandler>>;

export const parseResourceCtaAction = (link: string): string | null => {
  try {
    const url = new URL(link);

    if (url.protocol !== RESOURCE_CTA_ACTION_PROTOCOL) {
      return null;
    }

    return url.hostname || null;
  } catch {
    return null;
  }
};
